"use client";

import React, { useEffect } from "react";
import Bugsnag from "@bugsnag/js";
import { safeSessionStorage } from "@/utils/storage";
import ErrorFallback from "@/src/components/Common/ErrorFallback";

const CHUNK_RELOAD_KEY = "chunkReloadAt";
const CHUNK_RELOAD_WINDOW_MS = 10000;

export default function Error({ error }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    const isChunkError = error.name === "ChunkLoadError" || error.message.includes("Loading chunk");

    if (isChunkError && typeof window !== "undefined" && safeSessionStorage.isAvailable()) {
      const lastReloadAt = Number(safeSessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;

      if (Date.now() - lastReloadAt > CHUNK_RELOAD_WINDOW_MS) {
        safeSessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
        window.location.reload();
        return;
      }
    }

    Bugsnag.notify(error);
  }, [error]);

  return <ErrorFallback />;
}
